import api from './api';

const v2VaultSettingsService = {
  getSettingsByVaultId: async (v2_vault_id) => {
    const response = await api.get(`/v2-vault-settings?v2_vault_id=${v2_vault_id}`);
    return response.data;
  },

  upsertSetting: async (data) => {
    const response = await api.post('/v2-vault-settings', data);
    return response.data;
  },

  deleteSetting: async (id) => {
    const response = await api.delete(`/v2-vault-settings/${id}`);
    return response.data;
  }
};

export default v2VaultSettingsService;
